import { colorPalette } from '../../colorPalette';
export const wrapper = {
    margin: '0 32px',
    p: '40px 0',
};
export const title = {
    h1: {
        color: colorPalette.gray900,
        fontWeight: 600,
        fontSize: '3.2rem',
    },
};
export const subtitle = {
    color: colorPalette.gray700,
    fontSize: '1.8rem',
    lineHeight: '1.6',
};
export const faqTitle = {
    color: colorPalette.gray800,
    fontWeight: 600,
    fontSize: '1.6rem',
    lineHeight: '1.6',
};
export const legalNotice = {
    color: colorPalette.gray700,
    fontSize: '1.2rem',
    lineHeight: '1.2',
};
